'use strict';

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Reach = require('./reach');
var Types = require('./types');
var Utils = require('./utils');
var internals = {
  needsProtoHack: new Set([Types.set, Types.map, Types.weakSet, Types.weakMap])
};
module.exports = internals.clone = function (obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _seen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  var clone = internals.clone;
  var seen = _seen;
  if (options.shallow) {
    if (options.shallow !== true) {
      return internals.cloneWithShallow(obj, options);
    }
    clone = function clone(value) {
      return value;
    };
  } else if (seen) {
    var lookup = seen.get(obj);
    if (lookup) {
      return lookup;
    }
  } else {
    seen = new Map();
  }

  // Built-in object types

  var baseProto = Types.getInternalProto(obj);
  if (baseProto === Types.buffer) {
    return Buffer && Buffer.from(obj); // $lab:coverage:ignore$
  }
  if (baseProto === Types.date) {
    return new Date(obj.getTime());
  }
  if (baseProto === Types.regex) {
    return new RegExp(obj);
  }

  // Generic objects

  var newObj = internals.base(obj, baseProto, options);
  if (newObj === obj) {
    return obj;
  }
  if (seen) {
    seen.set(obj, newObj); // Set seen, since obj could recurse
  }
  if (baseProto === Types.set) {
    var _iterator = _createForOfIteratorHelper(obj),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        newObj.add(clone(value, options, seen));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (baseProto === Types.map) {
    var _iterator2 = _createForOfIteratorHelper(obj),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          key = _step2$value[0],
          _value = _step2$value[1];
        newObj.set(key, clone(_value, options, seen));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  var keys = Utils.keys(obj, options);
  var _iterator3 = _createForOfIteratorHelper(keys),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _key = _step3.value;
      if (_key === '__proto__') {
        continue;
      }
      if (baseProto === Types.array && _key === 'length') {
        newObj.length = obj.length;
        continue;
      }
      var descriptor = Object.getOwnPropertyDescriptor(obj, _key);
      if (descriptor) {
        if (descriptor.get || descriptor.set) {
          Object.defineProperty(newObj, _key, descriptor);
        } else if (descriptor.enumerable) {
          newObj[_key] = clone(obj[_key], options, seen);
        } else {
          Object.defineProperty(newObj, _key, {
            enumerable: false,
            writable: true,
            configurable: true,
            value: clone(obj[_key], options, seen)
          });
        }
      } else {
        Object.defineProperty(newObj, _key, {
          enumerable: true,
          writable: true,
          configurable: true,
          value: clone(obj[_key], options, seen)
        });
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return newObj;
};
internals.cloneWithShallow = function (source, options) {
  var keys = options.shallow;
  options = Object.assign({}, options);
  options.shallow = false;
  var seen = new Map();
  var _iterator4 = _createForOfIteratorHelper(keys),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var key = _step4.value;
      var ref = Reach(source, key);
      if (typeof ref === 'object' || typeof ref === 'function') {
        seen.set(ref, ref);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return internals.clone(source, options, seen);
};
internals.base = function (obj, baseProto, options) {
  if (options.prototype === false) {
    // Defaults to true
    if (internals.needsProtoHack.has(baseProto)) {
      return new baseProto.constructor();
    }
    return baseProto === Types.array ? [] : {};
  }
  var proto = Object.getPrototypeOf(obj);
  if (proto && proto.isImmutable) {
    return obj;
  }
  if (baseProto === Types.array) {
    var newObj = [];
    if (proto !== baseProto) {
      Object.setPrototypeOf(newObj, proto);
    }
    return newObj;
  }
  if (internals.needsProtoHack.has(baseProto)) {
    var _newObj = new proto.constructor();
    if (proto !== baseProto) {
      Object.setPrototypeOf(_newObj, proto);
    }
    return _newObj;
  }
  return Object.create(proto);
};